import { inject, Injectable } from "@angular/core";
import { ApiClient, CreateSalesTouchpointRequest, IApiClient, SalesTouchpointInfo } from "../sdk/sdk";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SalesTouchpointService {
    private readonly sdk: IApiClient = inject(ApiClient);

    getSalesTouchpoints(opportunityId: string): Observable<SalesTouchpointInfo[]> {
        return this.sdk.getSalesTouchpoints(opportunityId);
    }

    createSalesTouchpoint(touchpoint: CreateSalesTouchpointRequest): Observable<SalesTouchpointInfo> {
        return this.sdk.createSalesTouchpoint(touchpoint);
    }
}